import { render, staticRenderFns } from "./input-group.vue?vue&type=template&id=60436688&"
import script from "./input-group.vue?vue&type=script&lang=js&"
export * from "./input-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports